import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from './configureStore';
import {Provider} from "react-redux"
import {BrowserRouter, HashRouter} from "react-router-dom"
import migrateStorage from './utils/migrateStorage';

// 执行存储迁移
migrateStorage();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
      <HashRouter>
       <App />
      </HashRouter>
      </PersistGate>
    </Provider>

    
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
